import React, {
  useState, useEffect, useRef,
} from 'react';
import { connect } from 'react-redux';
import { FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Typography } from 'antd';
import Icon from '@ant-design/icons';
import request from '../../../../../../logic/utils/request';
import RenderInputs from './RenderInputs';
import RenderButtons from './RenderButtons';
import randomId from '../../../../../../logic/utils/randomId';
import BottomScreen from './BottomScreen';
import Request from '../../../Devices/DeviceStyle/TerminalStyle/Terminal/utils/request';

function ScreenEdit({
  showError, preloader, dispatch,
}) {
  const navigate = useNavigate();
  const [zone, setZone] = useState([]);
  const [selectList, setSelectList] = useState({ select: [], multi: [] });
  const [screen, setScreen] = useState({ buttons: [], bottomBlock: { buttons: [], topText: '', bottomText: '' } });
  const [screenList, setScreenList] = useState([]);
  const { id, screenId } = useParams();
  // Снимок загруженного экрана — по нему понимаем, есть ли несохранённые правки
  const loadedScreen = useRef('');
  const create = screenId === 'new' || screen.type === 'preEntry';
  const [terminals, setTerminals] = useState([]);

  const isValid = screen.headTitle && screen.type;

  const getTerminals = async () => {
    const { data: { data } } = await request('/server/api/satellite/', 'get');
    const term = data.filter((el) => el.type === 'terminal');
    setTerminals(term);
  };

  const setSelectTerminal = async (el) => {
    const { data } = await Request(`/server/public/satellite/${el.id}/`);
    dispatch({ type: 'SET_CONFIG', payload: data.data[0] });
  };

  const fetchFields = async () => {
    preloader();
    const res = await request('/server/api/ticketsfields/', 'get');
    preloader();
    const select = [];
    const multi = [];
    res.data.data.forEach((field) => {
      if (field.type === 'select') {
        select.push(field);
      } else if (field.type === 'multiselect') {
        multi.push(field);
      }
    });
    setSelectList({ select, multi });
  };

  const fetchScreens = async () => {
    preloader();
    try {
      const res = await request(`/server/api/zone/${id}`, 'get');
      preloader();
      if (res.data.data) {
        res.data.data.config.screens.forEach((sc) => sc.buttons.forEach((btn) => {
          btn.icon = btn.icon || false;
        }));
        setZone(res.data.data);
        setScreenList(res.data.data.config.screens);
        res.data.data.config.screens.forEach((item) => {
          if (item.screenId === screenId) {
            const loaded = {
              ...item,
              bottomBlock: item.bottomBlock || { buttons: [], topText: '', bottomText: '' },
            };
            loadedScreen.current = JSON.stringify(loaded);
            setScreen(loaded);
          }
        });
      }
    } catch (e) {
      const text = { text: { rus: 'Зона недоступна' } };
      showError(text);
    }
  };

  const addScreen = async () => {
    if (isValid) {
      const screens = [...zone.config.screens];
      screen.screenId = randomId(5);
      if (screen.type === 'infoScreen') {
        screen.data = '';
      }
      screens.push(screen);
      const newData = { ...zone, config: { ...zone.config, screens } };
      preloader();
      await request(`/server/api/zone/${id}/`, 'update', newData).catch((err) => {
        showError(err.data.error);
      });
      preloader();
      fetchScreens();
      navigate(-1);
      toast.success('Экран добавлен');
    }
  };

  const updateScreen = async (addBtn) => {
    if (isValid || addBtn) {
      const screens = [...screenList];
      const newScreens = screens.map((item) => {
        if (item.screenId === screen.screenId) {
          return screen;
        }
        return item;
      });
      const newData = {
        ...zone,
        config: { ...zone.config, screens: newScreens },
      };
      preloader();
      await request(`/server/api/zone/${id}/`, 'update', newData).catch((err) => {
        showError(err.data.error);
      });
      preloader();
      fetchScreens();
      toast.success('Экран обновлен');
    }
  };

  useEffect(() => {
    getTerminals();
    fetchFields();
  }, []);

  useEffect(() => {
    const empty = { buttons: [], bottomBlock: { buttons: [], topText: '', bottomText: '' } };
    loadedScreen.current = JSON.stringify(empty);
    setScreen(empty);
    fetchScreens();
  }, [screenId]);

  const dictOptions = screen.type === 'multiScreen' ? [...selectList.multi] : [...selectList.select];

  const changeScreen = (value, param) => {
    // console.log('value === ', value);
    // const regex = /(<([^>]+)>)/ig;
    // const result = value.replace(regex, '');
    console.log('changeScreen value === ', value);
    setScreen({ ...screen, bottomBlock: { ...screen.bottomBlock, [param || 'data']: value } });
  };

  const screenTypes = [
    { id: 'startScreen', name: 'Начальный экран' },
    { id: 'dictScreen', name: 'Экран одиночного выбора' },
    { id: 'inputScreen', name: 'Экран с полями ввода' },
    { id: 'btnScreen', name: 'Экран с кнопками' },
    { id: 'multiScreen', name: 'Экран множественного выбора' },
    { id: 'addressScreen', name: 'Экран ввода адреса' },
    { id: 'infoScreen', name: 'Информационный экран' },
  ];

  console.log(screen);
  console.log(create);

  if (zone) {
    return (
      <>
        <Button
          type="primary"
          shape="circle"
          icon={<Icon component={FaArrowLeft} />}
          onClick={() => navigate(-1)}
        />
        <Typography.Title style={{ textAlign: 'center', color: '#25547A' }}>
          {!create ? (
            <>
              Изменение экрана -
              {' '}
              <span style={{ color: '#f54c03' }}>
                {screen.headTitle}
              </span>
              {' '}
            </>
          ) : 'Создание экрана'}
        </Typography.Title>

        <RenderInputs
          terminals={terminals}
          setTerminal={setSelectTerminal}
          screenList={screenList}
          setScreenList={setScreenList}
          setScreen={setScreen}
          nowScreen={screen}
          dictOptions={dictOptions}
          screenTypes={screenTypes}
          isValid={isValid}
          updateScreen={updateScreen}
          addScreen={addScreen}
          create={create}
        />
        {!create
          ? (
            <>

              <RenderButtons
                screen={screen}
                screenList={screenList}
                preloader={preloader}
                dictOptions={dictOptions}
                updateScreen={updateScreen}
              />

              { (screen.type === 'infoScreen' || screen.type === 'startScreen') && screen.bottomBlock && (
              <BottomScreen
                screenList={screenList}
                screen={screen}
                updateScreen={updateScreen}
                changeScreen={changeScreen}
                showError={showError}
              />
              )}
            </>
          )
          : null}
      </>
    );
  }
  return null;
}

export default connect()(ScreenEdit);
